var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLupe = function SvgLupe(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M10.896 16.793a6.87 6.87 0 0 0 4.184-1.413l4.362 4.362a.92.92 0 0 0 1.3-1.3l-4.362-4.363a6.897 6.897 0 1 0-5.484 2.714m5.058-6.897a5.058 5.058 0 1 1-10.115 0 5.058 5.058 0 0 1 10.115 0",
    clipRule: "evenodd"
  })));
};
export default SvgLupe;